import styled from "styled-components";
import { MapContainer as LeafletMapContainer } from "react-leaflet";
import { FaMapMarkerAlt } from "react-icons/fa";

// Avatar Placeholder
export const AvatarPlaceholder = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px auto;
  color: #718096;
  font-weight: bold;
  font-size: 24px;
  text-transform: uppercase;
`;

export const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
`;

export const Sidebar = styled.div`
  width: 240px;
  background-color: #1e293b;
  color: white;
  padding: 20px;
`;

export const SidebarTitle = styled.h2`
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: bold;
`;

export const MenuButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  text-align: left;
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 6px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #334155;
  }

  ${props => props.active && `
    background-color: #334155;
  `}
`;

export const MainContent = styled.div`
  flex-grow: 1;
  padding: 30px;
  background-color: #f8fafc;
  text-align: center;
`;

export const FilterArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  gap: 10px;

  .input {
    padding: 10px 15px;
    border: 1px solid #cbd5e0;
    border-radius: 8px;
    font-size: 16px;
    width: 250px;
    transition: all 0.3s ease;

    &:focus {
      outline: none;
      border-color: #4299e1;
      box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
    }
  }
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 25px;
  justify-content: center;
  padding: 0 30px 50px;
  max-width: 1400px;
  margin: 0 auto;
`;

export const VisitaCard = styled.div`
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.03);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const VisitaCardTitle = styled.h4`
  margin: 10px 0;
  font-size: 18px;
  color: #2d3748;
  text-align: center;
  font-weight: 600;
`;

export const VisitaCardParagraph = styled.p`
  margin: 5px 0;
  font-size: 14px;
  color: #718096;
  text-align: center;
`;

export const Title = styled.div`
  width: 100%;
  text-align: center;
  margin: 30px 0 40px 0;
  
  h1 {
    color: #2d3748;
    font-size: 28px;
    font-weight: 600;
    position: relative;
    display: inline-block;

    &::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 60px;
      height: 3px;
      background-color: #4299e1;
    }
  }
`;

// Estilo para o modal de localização
export const MapModalOverlay = styled.div`
  position: relative;
  height: 100%;
`;

export const MapAddressDisplay = styled.div`
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(255, 255, 255, 0.9);
  padding: 10px;
  border-radius: 8px;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 80%;
`;

export const MapContainer = styled(LeafletMapContainer)`
  height: calc(100% - 50px);
  margin-top: 50px;
`;

export const RecordTimestampContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

export const RecordTimestamp = styled.span`
  font-weight: bold;
  margin-right: 8px;
`;

export const MapMarkerIcon = styled(FaMapMarkerAlt)`
  font-size: 18px;
  color: #007BFF;
  cursor: pointer;
`;

export const CloseMapButton = styled.button`
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 20px;
  background-color: #007BFF;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;